import React, { useRef, useState, useEffect } from "react";
import videoClose from '@/assets/images/video-close.svg'
import videoPlay from '@/assets/images/video-play-btn.svg'
import ReactWOW from "react-wow";


function loadYoutubeAPI(onload) {
  const script = document.createElement('script');
  script.src = 'https://www.youtube.com/iframe_api';

  const firstScriptTag = document.getElementsByTagName('script')[0];
  (firstScriptTag.parentNode || {}).insertBefore(script, firstScriptTag);

  script.onload = () => {
    onload();
  }
}

const Video = ({ message = {}, children }) => {
  const { videoKey = 'wgQUkza0vSM', videoImg, playId } = message;
  const videoWrapper = useRef();
  const dialogRef = useRef();
  const videoRef = useRef();
  const [open, setOpen] = useState(false);
  const [dialogContentStyle, setDialogContentStyle] = useState({});
  const [player, setPlayer] = useState({});
  const url = videoImg ? videoImg : `https://i.ytimg.com/vi/${videoKey}/maxresdefault.jpg`;

  const imgCss = {
    backgroundImage: `url(${url})`
  }


  function onYouTubeIframeAPIReady(id, config) {
    if (!config.videoId) {
      return null;
    }
  
    return new Promise(resolve => {
      const timer = setInterval(() => {
        if (window.YT && window.YT.Player) {
          clearInterval(timer);
          const play = new window.YT.Player(id, {
            height: '400',
            width: '1680',
            ...config
          });
          resolve(play);
        }
      }, 500);
    });
  }

  async function initPlayer(id) {
      let width = videoWrapper.current.clientWidth * 0.71;
      width = width >= 500 ? width : videoWrapper.current.clientWidth;
      const height = 674 * width / 1199;
      const playerIframe = await onYouTubeIframeAPIReady(id, {
        height,
        width,
        videoId: videoKey || '',
        playsinline: 0
      });
      setPlayer(playerIframe);
      const windowHeight = document.documentElement.clientHeight;
      const top = (windowHeight - height - 62) / 2;
      setDialogContentStyle({
        top: top > 62 ? `${top}px` : '30px',
        width: `${width}px`
      })
  }

  function playVideo() {
    setOpen(true);
    player && player.seekTo && player.seekTo(0);
  }

  function closeVideo() {
    setOpen(false);
    player && player.stopVideo();
  }

  useEffect(() => {
    loadYoutubeAPI(() => {
      initPlayer(playId);
    })
  }, [])
  
  return (
    <div className="video-wrapper" ref={videoWrapper} style={imgCss}>
      <div className="player" onClick={playVideo}>
        {
          children ? children : (
            <img src={videoPlay}/>
          )
        }
      </div>
      <div className="dialog" ref={dialogRef} style={open ? null : {display: 'none'}}>
        <div className="content" style={dialogContentStyle}>
          <span className="btn-close" onClick={closeVideo}>
            <img alt="close" src={videoClose}/>
          </span>
          <div id={playId} ref={videoRef} ></div>
        </div>
      </div> 
    </div>
  )
}


export default Video;
